import { DocumentUploadRequest } from 'vopay';
import { useEffect } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useUploadDocument() {
  const source = axios.CancelToken.source();

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  const uploadDocument = async (request: DocumentUploadRequest) => {
    try {
      const res = await api.uploadDocument(request, source);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (err) {
      console.error(err);

      throw err;
    }
  };

  return {
    uploadDocument,
  };
}
